'use strict';
import $ from 'jquery';

export default class SmoothScroll {
    static init() {
        $('a[href^="#"]:not(.no-smooth-scroll)').each((index, el) => {
            new SmoothScroll($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.on('click', this.onClick.bind(this));
    }

    onClick(e) {
        const self = this;
        const href = $(e.currentTarget).attr('href');
        if ('#' !== href && $(href).is(':visible')) {
            e.preventDefault();
            let offset = $(href).offset().top;
            if ($('header').length) {
                offset -= $('header').outerHeight();
            }
            console.log("offset: ", offset);
            $('html,body').animate(
                {
                    scrollTop: offset,
                }, {
                duration: 500,
                easing: 'swing',
                complete: () => {
                    self.el.trigger('scrollComplete');
                }
            });
        }
    }
}
